<template>
    <Dialog v-model:visible="visible" :style="{ width: '300px' }" :header="dialogHeader" :modal="true" class="p-fluid dialog-header" @hide="$emit('hide-dialog', true)">
        <div class="field">
            <label for="name">Department Name:</label>
            <InputText :class="{ 'p-invalid': submitted && !department.name }" id="name" type="text" v-model="department.name" autofocus />
            <small class="p-invalid" v-if="submitted && !department.name">Department Name is required</small>
        </div>
        <div class="field">
            <custom-tree-select v-model="department.parent_id" label="Parent Department" :optionsTree="departmentTree" />
            <Button v-if="department.parent_id" label="Remove Parent" icon="pi pi-trash" class="p-button-warning" @click="removeParent" />
        </div>

        <template #footer>
            <Button label="Cancel" icon="pi pi-times" class="p-button-danger" @click="visible = false" />
            <Button label="Submit" icon="pi pi-check" class="p-button-success" @click="submit" />
        </template>
    </Dialog>
</template>

<script setup>
import CustomTreeSelect from '../../../../../modules/custom-inputs/CustomTreeSelect.vue';
import { storeToRefs } from 'pinia';
import { ref, defineEmits, computed, onUnmounted } from 'vue';
import { object, string } from 'yup';
import { departmentStore } from '../../../../../store/global-stores';
import { showToast } from '../../../../../utilities/toast-handler';

// emit
const emit = defineEmits(['hide-dialog']);

const visible = ref(true);
const submitted = ref(false);

const { department, departmentTree, editId } = storeToRefs(departmentStore);

// computed properties starts
const dialogHeader = computed(() => {
    return editMode.value ? 'Update Existing Department' : 'Add New Department';
});

const editMode = computed(() => {
    return editId.value;
});

const validationSchema = object({
    name: string().required('Department Name is required'),
});

onUnmounted(() => {
    departmentStore.initdepartment();
});

const removeParent = () => {
    department.value.parent_id = null;
};

const submit = async () => {
    try {
        submitted.value = true;
        await validationSchema.validate(department.value, { abortEarly: false });
        const response = editMode.value ? await departmentStore.updateDepartment() : await departmentStore.createDepartment();
        if (response) {
            emit('hide-dialog');
        }
    } catch (error) {
        if (error.inner && typeof error.inner === 'object') {
            showToast({}, 'Input data invalid');
        }
    }
};
</script>
